/**
 * @module distributions
 */
import { createReducer } from '@reduxjs/toolkit';

const defaultState = {};

const distributions = createReducer(defaultState, () => {});

export default distributions;
